import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    filterData: [],
    searchValue: "",
}

const DashboardTablefilterDataSlice = createSlice({
    name: 'filterDatas',
    initialState,
    reducers: {
        setFilterData: (state, action) => {
            state.filterData = action.payload
        },
        setSearchData: (state, action) => {
            state.searchValue = action.payload
        }
    }
})

export const { setFilterData, setSearchData } = DashboardTablefilterDataSlice.actions

export default DashboardTablefilterDataSlice.reducer